import { render, staticRenderFns } from "./ScoutTabRecommendation.vue?vue&type=template&id=0ea4eb98"
import script from "./ScoutTabRecommendation.vue?vue&type=script&lang=js"
export * from "./ScoutTabRecommendation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports